import { createManifestUrl } from './utils/utilities';
import Head from 'next/head';

type PlatformMetadataComponentProps = {
    whitelabellingContent: WhiteLabellingContent,
    whitelabellingContentRequestPayload: WhiteLabellingContentRequestPayload
}

const PlatformMetadataComponent = ({ whitelabellingContent, whitelabellingContentRequestPayload }: PlatformMetadataComponentProps) => {

    const { domain, organizationName } = whitelabellingContentRequestPayload;
    const baseUrl = (domain ?? '').replace(/\/$/, '');
    const pageUrl = organizationName ? `${baseUrl}/${organizationName}` : (domain ?? '');
    const imageUrl = `${baseUrl}${whitelabellingContent.seo.image}`;

    return (
        <Head>
            {/* Browser display: mobile viewport, iOS web-app mode, and theme color */}
            <meta key="viewport" name="viewport" content="viewport-fit=cover, width=device-width, initial-scale=1.0, maximum-scale=1" />
            <meta key="apple-touch-fullscreen" name="apple-touch-fullscreen" content="yes" />
            <meta key="apple-mobile-web-app-capable" name="apple-mobile-web-app-capable" content="yes" />
            <meta key="apple-mobile-web-app-status-bar-style" name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
            <meta key="theme-color" name="theme-color" content="#0f172a" />

            {/* Standard metadata: platform title, keywords, and author */}
            <meta key="meta-title" data-whitelabelling="title" name="title" content={whitelabellingContent.seo.title} />
            <meta key="keywords" data-whitelabelling="keywords" name="keywords" content={whitelabellingContent.seo.keywords.join(", ")} />
            <meta key="author" data-whitelabelling="author" name="author" content={whitelabellingContent.seo.author} />

            {/* Open Graph: link previews for Facebook, LinkedIn, and Microsoft Teams */}
            <meta key="og:title" data-whitelabelling="og:title" property="og:title" content={whitelabellingContent.seo.title} />
            <meta key="og:description" data-whitelabelling="og:description" property="og:description" content={whitelabellingContent.seo.description} />
            <meta key="og:image" data-whitelabelling="og:image" property="og:image" content={imageUrl} />
            <meta key="og:url" data-whitelabelling="og:url" property="og:url" content={pageUrl} />
            <meta key="og:type" data-whitelabelling="og:type" property="og:type" content="website" />

            {/* Twitter/X: link preview title, description, image, and card format */}
            <meta key="twitter:card" data-whitelabelling="twitter:card" name="twitter:card" content="summary_large_image" />
            <meta key="twitter:title" data-whitelabelling="twitter:title" name="twitter:title" content={whitelabellingContent.seo.title} />
            <meta key="twitter:description" data-whitelabelling="twitter:description" name="twitter:description" content={whitelabellingContent.seo.description} />
            <meta key="twitter:url" data-whitelabelling="twitter:url" name="twitter:url" content={pageUrl} />
            <meta key="twitter:image" data-whitelabelling="twitter:image" name="twitter:image" content={imageUrl} />

            {/* Icons: browser favicon and Apple home-screen icon */}
            <link key="favicon" data-whitelabelling="favicon" rel="icon" href={whitelabellingContent.favicon.src} sizes={whitelabellingContent.favicon.sizes} />
            <link key="apple-touch-icon" data-whitelabelling="apple-touch-icon" rel="apple-touch-icon" href={whitelabellingContent.pwa.appleTouchIcon} />

            {/* PWA manifest: installed app name, icons, and launch settings */}
            <link key="manifest" data-whitelabelling="manifest" rel="manifest" href={createManifestUrl(whitelabellingContentRequestPayload)} />
        </Head>
    )
}

export default PlatformMetadataComponent
